import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Download, Loader2, RefreshCw } from "lucide-react";
import type { DateRangePreset } from "./utils";

type DashboardHeaderProps = {
  lastUpdated: Date | null;
  isRefreshing: boolean;
  datePreset: DateRangePreset;
  onDatePresetChange: (preset: DateRangePreset) => void;
  onRefresh: () => void;
  onDownload?: () => void;
  showDownload?: boolean;
};

export function DashboardHeader({
  lastUpdated,
  isRefreshing,
  datePreset,
  onDatePresetChange,
  onRefresh,
  onDownload,
  showDownload = true,
}: DashboardHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">
          Business overview for Americation operations
        </p>
        {lastUpdated && (
          <p className="text-xs text-muted-foreground mt-1">
            Last updated: {lastUpdated.toLocaleTimeString()}
          </p>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Select
          value={datePreset}
          onValueChange={(v) => onDatePresetChange(v as DateRangePreset)}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Date range" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="7d">Last 7 days</SelectItem>
            <SelectItem value="30d">Last 30 days</SelectItem>
            <SelectItem value="90d">Last 90 days</SelectItem>
          </SelectContent>
        </Select>
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={isRefreshing}>
          {isRefreshing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Refreshing
            </>
          ) : (
            <>
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh
            </>
          )}
        </Button>
        {showDownload && onDownload && (
          <Button size="sm" onClick={onDownload} disabled={isRefreshing}>
            <Download className="mr-2 h-4 w-4" />
            Export
          </Button>
        )}
      </div>
    </div>
  );
}
